import { useToastContext } from './ToastContext';
import { Toast, ToastOptions } from './types';

/**
 * Return functions to send toasts into the global toast container, or to clear them all.
 *
 * For the `showXyzToast()` functions, ToastOptions may be passed - right now used for `dismissAfterSeconds`.
 * Defaults to 10 seconsds for error toasts, 3 for all others. Pass 0 to cancel auto dismiss.
 */
export const useToasts = () => {
  const { addToast, clearToasts } = useToastContext();

  const showToast = (
    message: string,
    type: Toast['type'],
    options: ToastOptions
  ) => {
    const key = new Date().getTime().toString() + message;
    addToast({ message, type, key, ...options });
  };

  const showInfoToast = (message: string, options?: ToastOptions) => {
    showToast(message, 'info', options);
  };

  const showSuccessToast = (message: string, options?: ToastOptions) => {
    showToast(message, 'success', options);
  };

  const showErrorToast = (message: string, options?: ToastOptions) => {
    showToast(message, 'error', options);
  };

  return {
    showInfoToast,
    showSuccessToast,
    showErrorToast,
    clearToasts,
  };
};
